import { render, staticRenderFns } from "./InputPrependIcon.vue?vue&type=template&id=e0651748&"
import script from "./InputPrependIcon.vue?vue&type=script&lang=js&"
export * from "./InputPrependIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports